import React from 'react'

function Brokerage() {
    return (
        <div className='container'>
          <div className='row p-5 mt-5 text-center'>
            <div className='col-6 p-4'>
              <a href='#'  style={{textDecoration:"none"}}><h3>Brokerage Calculator</h3></a>
            </div>
            <div className='col-6 p-4'>
              <a href='#' style={{textDecoration:"none"}}><h3>List of charges</h3></a>
            </div>
          </div>
        </div>
      );
}

export default Brokerage;